import { StatusPopupData } from '../types/StatusPopup';
import { isObject } from 'core-lib/utils/helpers';
import { DictType } from 'core-lib/types/Helper';

export function formatStatusPopupData(data: DictType) {
  if (!isObject(data)) return null;

  const statusData: StatusPopupData = {
    img: data?.icon_url ?? null,
    title: data?.title ?? '',
    subtitle: data?.message ?? '',
    primaryBtn: {
      show: !!data?.primary_button_text,
      type: data?.primary_button_number
        ? 'call'
        : data?.redirect_url
        ? 'link'
        : null,
      label: data?.primary_button_text ?? '',
      value: data?.primary_button_number || data?.redirect_url || null,
    },
    secondaryBtn: {
      show: !!data?.secondary_button_text,
      type: null,
      label: data?.secondary_button_text ?? '',
      value: null,
    },
  };
  return statusData;
}
